import { getNewOrderNotification } from "../../config/Services";

let notificationInterval = null;
let subscribers = new Set();
let previousCreatedCount = null;
const INTERVAL = 20000;

const notifySubscribers = (payload) => {
  subscribers.forEach((cb) => cb(payload));
};

export const subscribeOrderNotification = (cb) => {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
};

export const startNotificationPolling = () => {
  if (notificationInterval) return;
  if (!localStorage.getItem("locId") || !localStorage.getItem("orgId")) return;

  const poll = () => {
    let locId = localStorage.getItem("locId");
    let orgId = localStorage.getItem("orgId");

    // Logged out (logout wipes localStorage): kill the timer instead of
    // polling with null ids. Covers every logout path, including ones that
    // never call stopNotificationPolling().
    if (!locId || !orgId) {
      stopNotificationPolling();
      previousCreatedCount = null;
      return;
    }

    getNewOrderNotification(locId, orgId)
      .then((res) => {
        const data = res?.data || {};
        const currentOrders = data?.currentOrders || {};
        const createdCount = currentOrders?.summary?.createdCount || 0;
        const hasNewOrder = previousCreatedCount !== null && createdCount > previousCreatedCount;
        const hasCreatedOrders = createdCount > 0;
        previousCreatedCount = createdCount;
        const hasFutureOrders = (data?.futureOrders?.summary?.createdCount || 0) > 0;  
        notifySubscribers({
          hasNewOrder,
          hasCreatedOrders,
          currentOrders,
          hasFutureOrders,
          raw: data,
        });
      })
      .catch(() => {});
  };

  poll(); // immediate
  notificationInterval = setInterval(poll, INTERVAL);
};

export const stopNotificationPolling = () => {
  if (notificationInterval) {
    clearInterval(notificationInterval);
    notificationInterval = null;
  }
};
